import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { RGBShiftShader } from 'three/examples/jsm/shaders/RGBShiftShader.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js'
import { TAARenderPass } from 'three/examples/jsm/postprocessing/TAARenderPass.js'

export const PostProcessProfileA = (renderer, scene, camera, w, h) => {
  const composer = new EffectComposer(renderer)
  const renderPass = new RenderPass(scene, camera)
  composer.addPass(renderPass)

  var effect = new ShaderPass(RGBShiftShader)
  effect.uniforms.amount.value = 0.0001
  composer.addPass(effect)
  composer.setSize(w, h)

  /*
  var fxaaPass = new ShaderPass(FXAAShader)
  var pixelRatio = renderer.getPixelRatio()
  fxaaPass.material.uniforms.resolution.value.x = 1 / (window.innerWidth * pixelRatio)
  fxaaPass.material.uniforms.resolution.value.y = 1 / (window.innerHeight * pixelRatio)
  composer.addPass(fxaaPass)
  */

  var taaRenderPass = new TAARenderPass(scene, camera)
  taaRenderPass.unbiased = false
  taaRenderPass.sampleLevel = 2
  composer.addPass(taaRenderPass)
  return composer
}
